export default{
  'overview_monthly_Monthly': '运营总况月报',
  'overview_monthly_MAU': '月活跃',
  'overview_monthly_Avg_MAU': '月平均活跃',
  'overview_monthly_DAU': '日活跃',
  'overview_monthly_New': '新进用户',
  'overview_monthly_WAU': '周活跃',
  'overview_monthly_Avg_WAU': '周平均活跃',
  'overview_monthly_Avg_DAU': '日平均活跃',

  'overview_monthly_New_Users': '新进用户',
  'overview_monthly_Retention_Users': '留存用户',
  'overview_monthly_Return_Users': '回流用户',

  // 卡片
  'overview_monthly_key_performance_metrics_explain_au': '统计周期内登录过游戏的用户数(vopenid数去重)，超过一月展示平均月活跃。',
  'overview_monthly_key_performance_metrics_explain_new': '统计周期内新注册用户数(vopenid数去重)，超过一月展示累计新进。',
  'overview_monthly_key_performance_metrics_explain_revenue': '统计周期内玩家的实际付费金额总额，超过一天展示累计付费。',
  'overview_monthly_key_performance_metrics_explain_arpu': '活跃ARPU=统计周期内消费额/活跃用户数。<br/>超过一月展示平均ARPU。统计周期内消费额的和/活跃用户数的和。',
  'overview_monthly_key_performance_metrics_explain_payer': '付费渗透率=统计周期内消费用户数/活跃用户数<br/>超过一月展示平均付费渗透率。统计周期内消费用户数的和/活跃用户数的和。',
  'overview_monthly_key_performance_metrics_explain_m2': '前一月次留，次月留存=XX注册日期第2月存留用户数/XX注册月新注册用户数，注册月是第一月。<br/>超过一月展示平均次月留存，统计周期内每一月注册用户次留用户数求和/统计周期内每一月新注册用户数求和。',

  'overview_monthly_Avg.Daily_New': '平均每日新进用户数',
  'overview_monthly_Month_Avg.DAU': '月平均日活跃',
  'overview_monthly_Month_Avg.Revenue($)': '月均付费金额({unit})',
  'overview_monthly_MAU_Breakdown': '月活跃用户构成',
  'overview_monthly_Month_M2': '次月留存',
  'overview_monthly_weighted_tab': '加权次月/3月留存',
  'overview_monthly_Month_M2/3': '次月留存/3月留存',
  'overview_monthly_Month_M2(T-1)': '次月留存(T-1)',
  'overview_monthly_Month_M3': '3月留存',
  'overview_monthly_Month_M4': '4月留存',
  'overview_monthly_MAU_Retention_Users': '月活留存',
  'overview_monthly_MAU_Return_Users': '月回流',
  'overview_monthly_avg_dau': '月平均DAU',
  'overview_monthly_Weighted_M2': '加权次月留存',
  'overview_monthly_Weighted_M3': '加权3月留存',
  'overview_monthly_Weighted_M2_short': '加权次月留存',
  'overview_monthly_Weighted_M3_short': '加权3月留存',
  'overview_monthly_Weighted_M4': '加权4月留存',

  // TODO: 暂无
  'overview_month_retention_2': '次月留存',
  'overview_month_retention_3': '3月留存',
  'overview_month_Weighted_2': '加权次月留存',
  'overview_month_Weighted_3': '加权3月留存',
  'overview_monthly_Last_Year': '去年同期',
  'overview_monthly_This_Month': '当月',

  'overview_monthly_Dowload_Date': '日期',
  'overview_monthly_Dowload_country': '国家',
  'overview_monthly_Dowload_Region': '区域',
  'overview_monthly_Dowload_Revenue': '付费金额',
  'overview_monthly_Dowload_netRevenue': '收入(剔除退款&税)',
  'overview_monthly_Dowload_MTX_Revenue': '内购收入',
  'overview_monthly_Dowload_Unit': '本体拷贝净销量',
  'overview_monthly_Dowload_New': '新进',
  'overview_monthly_Dowload_Share': '占比',
  'overview_monthly_Dowload_Zone': '区服',
  'overview_monthly_Dowload_Channel': '渠道',
  'overview_monthly_Dowload_PlatForm': '平台',
}
